import { cn } from "@omni/utils/styles";
import {
    ArrayPath,
    Controller,
    ControllerFieldState,
    ControllerRenderProps,
    FieldArrayWithId,
    Path
} from "react-hook-form";

import { BaseFieldArrayChildProps } from "@/components/Form/RHF/FormFields/BaseFieldArray/baseFieldArray.component";

import { TermsOfServiceFieldValues } from "../termsOfServiceCheck.schema";

type TermsOfServiceDocumentFieldProps<T extends TermsOfServiceFieldValues> =
    BaseFieldArrayChildProps<T> & {
        renderDocument: (
            fieldItem: FieldArrayWithId<T, ArrayPath<T>, "id">,
            field: ControllerRenderProps<T, Path<T>>,
            index: number,
            fieldState: ControllerFieldState
        ) => React.ReactNode;
    };

const TermsOfServiceDocumentField = <T extends TermsOfServiceFieldValues>({
    name,
    fields,
    control,
    renderDocument
}: TermsOfServiceDocumentFieldProps<T>) => {
    return fields.map((fieldItem, index) => {
        return (
            <div
                className={cn("tw:pb-4")}
                key={fieldItem.id}
            >
                <Controller<TermsOfServiceFieldValues>
                    control={control}
                    name={`${name}.${index}.checked`}
                    render={({ field, fieldState }) => {
                        return (
                            <>
                                {renderDocument(
                                    fieldItem,
                                    field,
                                    index,
                                    fieldState
                                )}
                            </>
                        );
                    }}
                />
            </div>
        );
    });
};

export { TermsOfServiceDocumentField };
